import {
    CashAcceptorStatusCode,
    CashReceivingStatus,
} from '@b2bsoft/kiosk-shell-sdk';

export const cashAcceptorReceivingErrorMap: { [key: number]: string } = {
    [CashReceivingStatus.Disconnected]: 'The Cash Acceptor is disconnected',
    [CashReceivingStatus.Rejected]:
        'Inserted banknote is not valid Please try again or use another banknote',
    [CashReceivingStatus.Jammed]:
        'The Cash Acceptor is jammed and will not continue normal operations until this situation is resolved',
    [CashReceivingStatus.Stalled]:
        'The device is stalled and will not continue normal operations until this situation is resolved',
    [CashReceivingStatus.Failed]:
        'The device has entered a failure mode and will not continue normal operations until this situation is resolved This usually requires a device restart',
    [CashReceivingStatus.CashOverflow]: 'Cash acceptor is full',
    [CashReceivingStatus.CassetteRemoved]: "Cash acceptor's cassete is removed",
};

export const cashAcceptorStatusErrorMap: { [key: number]: string } = {
    [CashAcceptorStatusCode.Offline]: 'The Cash Acceptor is disconnected',
    [CashAcceptorStatusCode.NeedUserIntervention]:
        'The device has entered a failure mode and will not continue normal operations until this situation is resolved This usually requires a device restart',
    [CashAcceptorStatusCode.Failed]:
        'The device has entered a failure mode and will not continue normal operations until this situation is resolved This usually requires a device restart',
    [CashAcceptorStatusCode.CashOverflow]: 'Cash acceptor is full',
    [CashAcceptorStatusCode.NoCassette]: "Cash acceptor's cassete is removed",
};

export const countryToCurrencySignMap: { [key: string]: string } = {
    USD: '$',
};
